import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 760px;
  margin: 170px 0px 0px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);

  // Title
  h2 {
    text-align: center;
    margin: 0px 0px 0px 0px;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.25em;
    color: var(--black);
    letter-spacing: -0.015em;
  }

  // Questions Container
  .questionsContainer {
    width: 100%;
    max-width: 760px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
  }

  .dropDownContainer {
    background-color: white;
    width: 100%;
    margin: 45px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    border: 1px solid var(--orange);
    border-radius: 12px;
    transition: 0.2s all;
  }

  .dropDownContainerOpen {
    background-color: white;
    width: 100%;
    margin: 45px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    text-align: center;
    border: 1px solid var(--orange);
    border-radius: 12px 12px 12px 12px;
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    transition: 0.2s all;
  }

  // 1710px Desktop  ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Title
    h2 {
      font-size: 2em;
    }
  }

  // 1440px Desktop  ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Title
    h2 {
      font-size: 1.9em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    max-width: 670px;
    margin: 130px 0px 0px 0px;

    // Questions Container
    .questionsContainer {
      max-width: 670px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    margin: 110px 0px 0px 0px;
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 570px;

    // Questions Container
    .questionsContainer {
      max-width: 570px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 480px;

    // Title
    h2 {
      line-height: 46px;
    }

    // Questions Container
    .questionsContainer {
      max-width: 480px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    max-width: 440px;

    // Questions Container
    .questionsContainer {
      max-width: 440px;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    max-width: 400px;
    margin: 80px 0px 0px 0px;

    // Questions Container
    .questionsContainer {
      max-width: 400px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Title
    h2 {
      text-align: left;
      line-height: 46px;
    }
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;
    margin: 80px 0px 0px 0px;

    // Questions Container
    .questionsContainer {
      max-width: 100%;
    }
  }
`;

export default Container;
